export default "__VITE_ASSET___2iPh3TP__"